<lyceo-content [background]="true">
  <lyceo-single-card-layout [logo]="true">
    <h3 class="mb-3" header>Geen toegang</h3>
    <p class="mb-3">Je hebt geen toegang tot Homi Dashboard</p>
    <button lyceoButton (click)="logout()" [block]="true">
      <fa-icon [icon]="faRightFromBracket" />
      Uitloggen
    </button>
  </lyceo-single-card-layout>
</lyceo-content>
